var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path, _polygon, _polygon2, _polygon3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFa00(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.51,
    y: 13.87,
    width: 0.98,
    height: 0.98
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17.49,
    y: 14.85,
    width: 0.98,
    height: 0.98
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.47,
    y: 13.87,
    width: 0.98,
    height: 0.98
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.45,
    y: 14.85,
    width: 0.98,
    height: 0.98
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 13.87,
    width: 0.98,
    height: 0.98
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4,
    y: 13.87,
    width: 0.98,
    height: 0.98
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18.47,
    y: 15.83,
    width: 0.98,
    height: 0.98
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 15.83,
    width: 0.98,
    height: 0.98
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4,
    y: 15.83,
    width: 0.98,
    height: 0.98
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 21.42,
    y: 14.85,
    width: 0.98,
    height: 0.98
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 19.45,
    y: 16.82,
    width: 0.98,
    height: 0.98
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 21.42,
    y: 16.82,
    width: 0.98,
    height: 0.98
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 17.8,
    width: 0.98,
    height: 0.98
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 21.42,
    y: 18.78,
    width: 0.98,
    height: 0.98
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 15.53,
    width: 8.8,
    height: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.5,22.55c-1.64,1.64-1.64,4.3,0,5.94l.28.28c1.64,1.64,4.3,1.64,5.94,0l7.86-7.7-6.22-6.22-7.86,7.7Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "13.46 6.07 10.64 6.07 13.46 12.06 13.46 6.07"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "6.06 14.91 6.06 17.74 12.05 14.91 6.06 14.91"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "7.56 8.38 5.68 10.86 11.66 13 7.56 8.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFa00);
export default __webpack_public_path__ + "static/media/FA00.ab4984482542de5441d54594284a3add.svg";
export { ForwardRef as ReactComponent };